// 官网提示说明（非表单）
export default {
  直播中: '直播中',
  看回放: '看回放',
  直播状态: '直播状态',
  直播频道: '直播频道',
  暂无相关直播: '暂无相关直播',
  直播不存在: '直播不存在',
  已下架: '已下架',
  直播公告: '直播公告',
  直播已结束: '直播已结束',
  直播已禁播: '直播已禁播',
  违规原因: '违规原因',
  推荐更多精彩直播: '推荐更多精彩直播',
  Ta的直播产品: 'Ta的直播产品',
  相似直播推荐: '相似直播推荐',
  预告: '预告',
  开播时间: '开播时间',
  收费价格: '收费价格(金币)',
  观看是否收费: '观看是否收费',
  直播展览: '直播展览',
  直播会议: '直播会议',
  付费: '付费',
  免费: '免费',
  直播产品: '直播产品',
  立即下单: '立即下单',
  正在直播推荐: '正在直播推荐',
  直播推荐: '直播推荐',
  全部评论: '全部评论',
  欢迎来到直播间提示:
    '欢迎来到直播间！云展动力提倡绿色健康直播！直播内容与弹幕严禁出现违法违规、低俗色情、吸烟酗酒等内容,一经违反发现,直接永久禁播封停账号！',
  回车Enter发送: '回车Enter发送',
  发送评论每次最多30个字符: '发送评论,每次最多30个字符,回车Enter发送....',
  您未登录请登录后在发言: '您未登录,请登录后在发言',
  直播服务购买: '直播服务购买',
  总费用: '总费用',
  聊一聊: '聊一聊',
  前往详情: '前往详情',
}
